import { createFileRoute } from '@tanstack/react-router'
import SettingsLinkedInCookies from '@/features/settings/linkedin-cookies'

export const Route = createFileRoute('/_authenticated/settings/linkedin-cookies')({
  component: SettingsLinkedInCookies,
})
